import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <ContactSection />
        <IndexSection />
        <CommentsSection />
        <FAQSection />
        <CarouselSection />
        <CardsSection />
        <AppSection />
        <UpdatesSection />
        <AboutSection />
        <FeaturesSection />
        <RankingSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}